import { OfferTypes } from '../../../core/types';
import { PaymentMethod } from '../constants';
const filterIncentiveOffers = (offers) => offers.filter(offer => [OfferTypes.NonStackableRebate, OfferTypes.StackableRebate].includes(offer.type));
export const filterSpecialPaymentOffers = (offerGroups) => offerGroups
    .map(offerGroup => {
    const { incentiveOffers } = offerGroup;
    return {
        ...offerGroup,
        incentiveOffers: {
            ...incentiveOffers,
            cash: filterIncentiveOffers(incentiveOffers.cash),
            finance: filterIncentiveOffers(incentiveOffers.finance),
            lease: filterIncentiveOffers(incentiveOffers.lease),
        },
    };
})
    .filter(offerGroup => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const hasLoyaltyOffer = ((_b = (_a = offerGroup.loyaltyOffers) === null || _a === void 0 ? void 0 : _a.finance) === null || _b === void 0 ? void 0 : _b.length) ||
        ((_d = (_c = offerGroup.loyaltyOffers) === null || _c === void 0 ? void 0 : _c.lease) === null || _d === void 0 ? void 0 : _d.length) ||
        ((_f = (_e = offerGroup.loyaltyOffers) === null || _e === void 0 ? void 0 : _e.cash) === null || _f === void 0 ? void 0 : _f.length);
    const hasIncentiveSpecialOffer = ((_h = (_g = offerGroup.incentiveOffers) === null || _g === void 0 ? void 0 : _g.finance) === null || _h === void 0 ? void 0 : _h.length) ||
        ((_k = (_j = offerGroup.incentiveOffers) === null || _j === void 0 ? void 0 : _j.lease) === null || _k === void 0 ? void 0 : _k.length) ||
        ((_m = (_l = offerGroup.incentiveOffers) === null || _l === void 0 ? void 0 : _l.cash) === null || _m === void 0 ? void 0 : _m.length);
    return hasLoyaltyOffer || hasIncentiveSpecialOffer;
});
export const filterTrimsWithValidSpecialOffers = (trimsWithOffers) => trimsWithOffers.filter(trim => [PaymentMethod.cash, PaymentMethod.lease, PaymentMethod.finance].some(paymentMethod => {
    var _a, _b, _c, _d, _e, _f;
    return ((_b = (_a = trim.offers.incentiveOffers) === null || _a === void 0 ? void 0 : _a[paymentMethod]) === null || _b === void 0 ? void 0 : _b.length) ||
        ((_d = (_c = trim.offers.loyaltyOffers) === null || _c === void 0 ? void 0 : _c[paymentMethod]) === null || _d === void 0 ? void 0 : _d.length) ||
        ((_f = (_e = trim.offers.bonusOffers) === null || _e === void 0 ? void 0 : _e[paymentMethod]) === null || _f === void 0 ? void 0 : _f.length);
}));
